import cx from 'classnames';
import React from 'react';

import * as styles from './ResourceGrid.module.css';

const ResourceGrid = ({
	children,
	layout,
}: {
	children: React.ReactNode[];
	layout: 'list' | 'card';
}) => {
	return (
		children && (
			<div
				className={cx(styles.resourceGrid, {
					[styles[`${layout}Layout`]]: layout,
				})}
			>
				{children}
			</div>
		)
	);
};

export default ResourceGrid;
